<!-- template v.1 -->
<template>

</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
     

      
    };
  },
  mounted(){
    
    this.content.login = false;
    this.content.sistema = true;

  },
}
</script>
<style scoped>

</style>